import styled from 'styled-components';

const TD = styled.td`
  padding: 0.75rem;
  vertical-align: top;
  border: 1px solid #e9ecef;
`;

export default TD;



// WEBPACK FOOTER //
// ./app/components/Table/TD.js